lmApp
  .controller('TileShowcaseController', ['$scope', '$rootScope', '$interval', 'ShowcaseService', 'ToastService',
    function ($scope, $rootScope, $interval, ShowcaseService, ToastService) {

      $scope.namespace = 'stockmob';
      $scope.tile = $scope.$parent.tile;
      $scope.loading = false;
      $scope.showcasesCollection = [];

      ShowcaseService.GetScreens($rootScope.currentPlatform.id)
        .then(function (screensCollection) {
          $scope.showcasesCollection = screensCollection.map(function (showcase) {
            return {
              title: showcase.title,
              id: showcase.extid || '',
              showcase: {
                id: showcase.id,
                title: showcase.title,
                labels: showcase.extid
              }
            }
          });

          if ($scope.showcasesCollection.length) {
            for (var i = 0; i < $scope.showcasesCollection.length; i++) {
              if ($scope.showcasesCollection[i].id === $scope.tile.banner.widget_attrs.showcase) {
                $scope.tile.banner._PrivateData.selectedShowcase = {
                  title: $scope.showcasesCollection[i].title,
                  id: $scope.showcasesCollection[i].id,
                  showcase: {
                    id: $scope.showcasesCollection[i].id,
                    title: $scope.showcasesCollection[i].title,
                    labels: $scope.showcasesCollection[i].showcase.labels
                  }
                }
              }
            }
          } else {
            $scope.tile.banner._PrivateData.selectedShowcase = {
              title: '',
              id: null,
              showcase: {
                id: null,
                _PrivateData: {}
              }
            };
          }
        })
        .catch(function (reason) {
          $rootScope.debugInfo(reason, 'silent');
          ToastService.Small({
            title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
            color: 'amber',
            icon: 'server-off',
            blocked: true
          }, 1000 * 3);
          $scope.showcasesCollection = [];
        });

      $scope.validate = function (banner) {
        $scope.validateFields = {};

        if (!banner._PrivateData.uiTitle) {
          $scope.validateFields.uiTitle = 'Required filed';
        }

        if (!banner._PrivateData.picture) {
          $scope.validateFields.picture = 'Required filed';
        }

        if (!banner._PrivateData.selectedShowcase.showcase.id) {
          $scope.validateFields.showcase = 'Required filed';
        }

        return $scope.validateFields;
      };

      $scope.updateWidget = function (tile) {
        if ($scope.loading) return;

        if (!_.isEmpty($scope.validate(tile.banner))) {
          return;
        }

        ShowcaseService.UpdateShowcaseWidget(tile.banner)
          .then(function (response) {
            $scope.loading = false;
            $rootScope.hideLinearProgress('#showcasesLoader');
            ToastService.Small({
              title: 'Widget successfully update',
              color: 'green',
              icon: 'view-carousel'
            });
            if (!tile._PrivateData.isSliderInner) $scope.close(tile);
          })
          .catch(function (reason) {
            ToastService.Small({
              title: 'Widget update failed',
              color: 'red',
              icon: 'view-carousel'
            });
            $scope.loading = false;
            $rootScope.hideLinearProgress('#showcasesLoader');
            $rootScope.debugInfo(reason);
          });
      };

      $scope.createWidget = function (item) {
        if ($scope.loading) return;

        if (!_.isEmpty($scope.validate(item.banner))) {
          return;
        }

        ShowcaseService.CreateShowcaseWidget(item.banner, $scope.namespace)
          .then(function (response) {
            item.banner.id = response.widget.id;

            if (item._PrivateData.isSliderInner) {
              $scope.$parent.createNewSliderItem(item)
            } else {
              $scope.$parent.createNewTile(item);
            }
          })
          .catch(function (reason) {
            ToastService.Small({
              title: 'Widget create failed',
              color: 'red',
              icon: 'view-carousel'
            });
            $scope.loading = false;
            $rootScope.hideLinearProgress('#showcasesLoader');
            $rootScope.debugInfo(reason);
          });
      };

      $scope.close = function (tile, event) {
        if (event && event.stopPropagation) event.stopPropagation();
        if (event && event.preventDefault) event.preventDefault();
        if ($scope.loading) return;

        if (tile.isNew) {
          $scope.$parent.deleteTile(tile, event)
        } else {
          $scope.$parent.collapseTile(tile);
        }
      };

    }]);
